/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type VestingInitialized = {
  vestingConfig: Address;
  launch: Address;
  baseMint: Address;
  totalAllocation: bigint;
  scheduleCount: number;
  allocationCount: number;
};

export type VestingInitializedArgs = {
  vestingConfig: Address;
  launch: Address;
  baseMint: Address;
  totalAllocation: number | bigint;
  scheduleCount: number;
  allocationCount: number;
};

export function getVestingInitializedEncoder(): FixedSizeEncoder<VestingInitializedArgs> {
  return getStructEncoder([
    ['vestingConfig', getAddressEncoder()],
    ['launch', getAddressEncoder()],
    ['baseMint', getAddressEncoder()],
    ['totalAllocation', getU64Encoder()],
    ['scheduleCount', getU8Encoder()],
    ['allocationCount', getU8Encoder()],
  ]);
}

export function getVestingInitializedDecoder(): FixedSizeDecoder<VestingInitialized> {
  return getStructDecoder([
    ['vestingConfig', getAddressDecoder()],
    ['launch', getAddressDecoder()],
    ['baseMint', getAddressDecoder()],
    ['totalAllocation', getU64Decoder()],
    ['scheduleCount', getU8Decoder()],
    ['allocationCount', getU8Decoder()],
  ]);
}

export function getVestingInitializedCodec(): FixedSizeCodec<
  VestingInitializedArgs,
  VestingInitialized
> {
  return combineCodec(
    getVestingInitializedEncoder(),
    getVestingInitializedDecoder(),
  );
}
